import { useHostingAdvancedServer } from '@newfold/huapi-js';

import { SSO_HOOK_OPTIONS } from '~/components/SSO/utils/helpers';
import {
  productTypes,
  useCtbProductInfo,
  useCtbPurchaseStatusQuery,
} from '~/hooks/useCtbProductInfo';
import {
  DISABLE_LAUNCH_CONSOLE_ACTION,
  TERMINAL_LAUNCH_CONSOLE_ACTION,
} from '~/Nova/scenes/HostingList/scenes/SelfManagedHosting/utils/constants';

type ConsoleAccessMode = 'launch' | 'terminal';

const STATUS_MAP = {
  launch: DISABLE_LAUNCH_CONSOLE_ACTION,
  terminal: TERMINAL_LAUNCH_CONSOLE_ACTION,
} as const;

const useIsConsoleAccessDisabled = (
  hostingId?: string | number,
  mode: ConsoleAccessMode = 'launch',
) => {
  const { data: serverData } = useHostingAdvancedServer(hostingId as any, {
    query: {
      ...SSO_HOOK_OPTIONS.query,
      enabled: !!hostingId,
    },
  });

  const productInfo = useCtbProductInfo(productTypes.HOSTING_UPGRADE);

  const { hasPurchasedRecently } = useCtbPurchaseStatusQuery(
    productInfo.purchaseQueryKey,
  );

  const serverStatus = serverData?.data?.status ?? '';

  const isServerBlocked = STATUS_MAP[mode].includes(serverStatus);

  return isServerBlocked || hasPurchasedRecently;
};

export default useIsConsoleAccessDisabled;
